import React, { Component } from 'react';
import Firebase from 'firebase';
import { Progress } from 'reactstrap';

export default class updatePhoto extends React.Component {
    constructor() {
        super();
        this.state = {
            display: "none"
        }
        this.uploadPhoto = this.uploadPhoto.bind(this);
    }


    uploadPhoto() {
        const contex = this;
        var metadata = {
            contentType: 'image/jpeg'
        };
        var storageRef = Firebase.storage().ref();
        var uploadTask = storageRef.child(localStorage.client_id + '/admin/' + localStorage.uid + '/profile').put(this.state.file, metadata);
        uploadTask.on(Firebase.storage.TaskEvent.STATE_CHANGED, // or 'state_changed'
            function (snapshot) {
                // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
                var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                contex.setState({ progress: progress });
                switch (snapshot.state) {
                    case Firebase.storage.TaskState.PAUSED: // or 'paused'
                        break;
                    case Firebase.storage.TaskState.RUNNING: // or 'running'
                        break;
                }
            }, function (error) {
                switch (error.code) {
                    case 'storage/unauthorized':
                        // User doesn't have permission to access the object
                        break;
                    case 'storage/canceled':
                        // User canceled the upload
                        break;
                    case 'storage/unknown':
                        // Unknown error occurred, inspect error.serverResponse
                        break;
                }
            }, function () {
                var downloadURL = uploadTask.snapshot.downloadURL;
                var usersRef = Firebase.database()
                    .ref('admin_users')
                    .child(localStorage.uid);
                usersRef.child("photo").set(downloadURL).then((resp) => {
                contex.props.callBack();
                });
            });
    }

    render() {
        var reader = new FileReader();
        return (
            <div>
                <div className="form-group" style={{ width: "80%", marginLeft: "10%" }}>
                    <div className="input-group image-preview">
                        <input placeholder="" type="text" className="form-control image-preview-filesheetName"
                            value={this.state.file ? this.state.file.name : ""} disabled="disabled"
                        />
                        <span className="input-group-btn">
                            <button
                                type="button"
                                className="btn btn-default image-preview-clear"
                                style={{ display: "none" }}>
                                <span
                                    className="glyphicon glyphicon-remove">
                                </span>
                                Clear
                                </button>
                            <div  className="btn btn-primary image-preview-input" onClick={() => { var l = document.getElementById('inputFile'); l.click(); }} >
                                <span
                                    className="image-preview-input-title">
                                    Buscar
                                    </span>
                                <input
                                    style={{ display: "none" }}
                                    id="inputFile"
                                    type="file"
                                    accept=".png,.jpg"
                                    sheetName="input-file-preview"
                                    onChange={(e) => {
                                        this.setState({ file: e.target.files[0], display: "" });
                                        reader.onload = function (e) {
                                            document.getElementById('img').src = e.target.result;
                                        }
                                        reader.readAsDataURL(e.target.files[0]);
                                    }}
                                />
                            </div>
                        </span>
                        <div style={{ display: this.state.display }} >
                            {
                                this.state.file !== {} ?
                                    <a  onClick={() => { this.uploadPhoto() }} className="btn btn-success">Subir foto</a>
                                    :
                                    ""
                            }
                        </div>
                    </div>
                </div>
                {
                    this.state.file ?
                        <div className="text-center">
                            <img id="img" src="" width="300" />
                            <br />
                            <br />
                            <Progress className="progress-xs" color="success" value={this.state.progress} id="progress" />
                        </div>
                        :
                        ""
                }

            </div>
        )
    }
}




// WEBPACK FOOTER //
// ./src/views/account/updatePhoto.js